import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { useContext, useEffect, useState } from "react";
import { dummyListKategori } from "../dummy-data";
import KategoriBox from "../components/KategoriBox";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import SearchInputText from "../components/SearchInputText";
import { Link } from "react-router-dom";
import UiContext from "../../../store/ui-context";
import { Dropdown } from "primereact/dropdown";
import AppContext from "../../../store/app-context";

const ListKategoriPage = () => {
  const appContext = useContext(AppContext);
  const uiContext = useContext(UiContext);
  const { requestGet, requestGetOne, requestPost, requestDelete } =
    useAPIRequest();
  const [loading, setLoading] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [listKategori, setListKategori] = useState([]);
  const [listKategoriSource, setListKategoriSource] = useState([]);

  // use effect section

  useEffect(() => {
    fetchListKategori();
  }, []);

  // api call section

  const fetchListKategori = async () => {
    const _filter = "";

    return requestGet({
      fullUrl: `/api/masterdata/produkkategori/data`,
      params: {
        page: 1,
        take: 1000,
        filter: _filter,
        order: "index",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        setListKategoriSource(data);
        setListKategori(data);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ui handler section
  const handleSearch = (filterText) => {
    setLoading(true);
    const _filterText = filterText.toLowerCase();
    if (_filterText.length > 0) {
      const _list = listKategoriSource.filter((item) =>
        item.nama.toLowerCase().includes(_filterText)
      );
      setListKategori(_list);
    } else {
      setListKategori(listKategoriSource);
    }
    setLoading(false);
  };

  return (
    <div className="col-start-start gap-1">
      {/* header section */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pt-2 pb-6">
        <div className="row-start-center gap-2 py-4">
          <Link className="px-1" to={-1}>
            <i className="pi pi-arrow-left text-slate-600 text-[0.8rem]" />
          </Link>
          <span className="text-slate-700 text-xl leading-none">Kategori</span>
        </div>

        {/* location */}
        <div className="col-center-center w-full pb-2">
          <div className="row-between-center w-full bg-stone-100 py-1 pl-2 pr-1 rounded">
            <span className="text-slate-500 min-w-[9rem]">
              Pilih Lokasi Anda
            </span>

            <Dropdown
              className="border-slate-300 w-full"
              value={appContext.selectedKota}
              onChange={(e) => appContext.setSelectedKota(e.value)}
              options={appContext.listKota}
              optionLabel="nama"
              placeholder="Pilih Kota"
              checkmark={true}
              highlightOnSelect={false}
              pt={{
                input: { className: "text-sm text-slate-500 font-semibold" },
              }}
            />
          </div>
        </div>

        {/* search  */}
        <SearchInputText
          loading={loading}
          value={filterText}
          autofocus={false}
          placeholder={`Find In Kategori`}
          onChange={(_text) => setFilterText(_text)}
          onSearch={(text) => handleSearch(text)}
        />
      </div>

      {/* list section  */}
      <div className="row-start-start bg-white w-full shadow-xs flex-wrap px-3 sm:px-5 py-4 gap-4">
        {listKategori.map((kategori) => (
          <KategoriBox key={kategori.id} {...kategori} />
        ))}
      </div>
    </div>
  );
};

export default ListKategoriPage;
